import { render, staticRenderFns } from "./PermissionsTable.vue?vue&type=template&id=bab2efde&"
import script from "./PermissionsTable.vue?vue&type=script&lang=ts&"
export * from "./PermissionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionsTable.vue?vue&type=style&index=0&id=bab2efde&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QTable,QTd,QCheckbox} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTd,QCheckbox})
